// TODO(coming-soon-bypass): Temporary route override.
//
// While TEMP_ALL_MENU_TO_COMING_SOON is true, every admin menu route renders the
// reusable AdminComingSoonPage instead of its real component. Real components
// stay imported in AdminRoutes.tsx — they are not deleted.
//
// To enable a single real page, add its path to TEMP_ENABLED_PATHS, e.g.:
//   export const TEMP_ENABLED_PATHS: readonly string[] = ['/role-management'];
//
// To fully restore the original behavior:
//   1. Delete src/pages/admin/_temp/ (this file).
//   2. Delete src/pages/admin/screens/_shared/AdminComingSoonPage.tsx.
//   3. In AdminRoutes.tsx, remove the temp imports and the isBypassed() ternaries.
//   4. Remove the `comingSoon:` block from ko/common.yaml and en/common.yaml.
//
// Grep for "coming-soon-bypass" to find every touch point.

export const TEMP_ALL_MENU_TO_COMING_SOON = true;

export const TEMP_ENABLED_PATHS: readonly string[] = [
  '/home',
  '/role-management',
  '/admin-management',
  '/patient-management',
  '/medical-staff-management',
  '/medical-staff-management/invite-email-preview',
  '/disease-code',
  '/terms-and-conditions-management',
  '/management-guidelines',
  '/counseling-manual',
  '/my-profile',
  '/biometric-data',
  '/log-inquiry',
  '/pro-item-design',
  '/questionnaire-design',
  '/health-encyclopedia',
  '/pro-deployment-management',
  '/notice-management',
  '/patient-inquiry-management',
  '/notification-settings',
];
